// 色の計算（色選びの画面の HSV など）（2026-10-21 に app.js から分けた）

// ---- 色の計算（キャラの色はエンジンと同じ charat.draw.js。色選びの画面の HSV だけはここで） ----
export function hexToRgb(hex: string): number[] {
  let h = String(hex).replace('#', '');
  if (h.length === 3) h = h.replace(/./g, '$&$&');
  return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
}
export function mix(fromHex: string, toHex: string, t: number) { return charatDraw.interpolateRgb(fromHex, toHex)(t); } // d3.interpolateRgb(from, to)(t)
